import { ChangeEvent, useState } from 'react';
import { InputProps } from '../model/types';

const useInputLogic = (props: InputProps) => {
  const { type, changeFunction } = props;

  const [isViewPassword, setIsViewPassword] = useState<boolean>(false);

  const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
    /*
     * Регулярка на валидацию, так как у input type text по default
     */
    if (type === 'number') {
      const regExp: RegExp = /^\d*$/;
      if (!regExp.test(e.target.value)) return;
    }
    changeFunction && changeFunction(e.target.value);
  };

  return {
    handleChange,
    isViewPassword,
    setIsViewPassword,
  };
};

export default useInputLogic;
